import { render, staticRenderFns } from "./shield_rules.vue?vue&type=template&id=352be2b0&scoped=true"
import script from "./shield_rules.vue?vue&type=script&lang=js"
export * from "./shield_rules.vue?vue&type=script&lang=js"
import style0 from "./shield_rules.vue?vue&type=style&index=0&id=352be2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352be2b0",
  null
  
)

export default component.exports